import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LogoMark from "@/components/LogoMark";

export default function Loader({ onDone }) {
  const [count, setCount] = useState(0);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const DURATION = 1800;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / DURATION);
      // ease-out cubic
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
      else {
        setTimeout(() => setExiting(true), 240);
        setTimeout(() => onDone?.(), 1140);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!exiting || count < 100 ? (
        <motion.div
          key="loader"
          data-testid="site-loader"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[999] flex flex-col justify-between bg-[#050505] p-6 md:p-10"
        >
          <div className="flex items-start justify-between">
            <div
              className="flex items-center gap-3 eyebrow"
              data-testid="loader-brand"
            >
              <LogoMark size={36} />
              <span>JLP / CONSTRUCT & REPAIR</span>
            </div>
            <div className="eyebrow">EST. · PA</div>
          </div>

          <div className="flex items-end justify-between">
            <div className="font-oswald text-[22vw] leading-none text-white/95 md:text-[16vw]">
              <span className="tabular-nums" data-testid="loader-counter">
                {String(count).padStart(3, "0")}
              </span>
              <span className="align-top text-[8vw] text-white/40 md:text-[3vw]">
                %
              </span>
            </div>
            <div className="hidden max-w-xs pb-6 text-right font-editorial text-lg italic text-white/70 md:block">
              Fixing homes.
              <br />
              Building dreams.
            </div>
          </div>

          <div className="relative mt-6 h-[2px] w-full bg-white/10">
            <motion.div
              className="absolute inset-y-0 left-0 bg-white"
              initial={{ width: "0%" }}
              animate={{ width: `${count}%` }}
              transition={{ ease: "linear", duration: 0.05 }}
            />
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
